/******/ (() => { // webpackBootstrap
/******/ 	"use strict";

;// ./src/javascripts/Component.js


class Component {
  /**
   * Generic component, inherited class will be called to receive things like resize events.
   *
   * @param {import('./ThemeBase').default} theme
   * @param {HTMLElement} element
   */
  constructor(theme, element) {
    this.theme = theme;
    this.element = element;
    theme.registerComponent(this);
  }

    /**
     * This will be called immediatelly when window resizes.
     *
     * NOTE: prefer using onWindowResize as it's already debounced.
     *
     * @param {Object} params
     * @param {number} params.width Width of the window
     */
    onWindowResizeRaw = ({ width }) => {}

    /**
     * This will be called regularly (throttled) when window is being resized.
     *
     * @param {Object} params
     * @param {number} params.width New width of the window
     * @param {number} params.oldWidth Width of the window last time this was called
     * @param {import("./constants").Breakpoint} params.breakpoint Current width breakpoint
     */
    onWindowResize = ({ width, oldWidth, breakpoint }) => {}

    /**
     * This will be called when window is being resized and it changes current breakpoint.
     *
     * @param {Object} params
     * @param {number} params.width New width of the window
     * @param {import("./constants").Breakpoint} params.breakpoint Current width breakpoint
     * @param {import("./constants").Breakpoint} params.oldBreakpoint Breakpoint last time this was called
     */
    onWindowResizeBreakpoint = ({ width, breakpoint, oldBreakpoint }) => {}

    /**
     * This will be called regularly (throttled) when window is scrolled
     */
    onWindowScroll = () => {}
}

;// ./src/javascripts/global/QuickAdd.js


class QuickAdd extends Component {
  constructor(theme, element) {
    super(theme, element);

    this.theme = theme;
    this.element = element;
    this.onSubmit = this.onSubmit.bind(this);
    this.isProcessing = false;
    this.cartAction = document.getElementById('PageContainer').dataset.cartAction;
    this.cartType = document.getElementById('PageContainer').dataset.cartType;
    this.languageUrl = document.getElementById('PageContainer').dataset.languageUrl;
    this.formWrappers = /** @type {NodeListOf<HTMLElement>} */ (this.element.querySelectorAll('.quick-add-wrapper.is-singular'));
    this.wethemeGlobal = document.querySelector('script#wetheme-global');
    this.translationsObject = JSON.parse(this.wethemeGlobal.textContent);

    if (!this.formWrappers.length) {
      return;
    }

    this.formWrappers.forEach((wrapper) => {
      const form = wrapper.querySelector('.shopify-product-form');
      if (form && !form.hasAttribute('data-quick-add-initialized')) {
        form.addEventListener('submit', this.onSubmit);
        form.setAttribute('data-quick-add-initialized', 'true');
      }
    });
  }

  async onSubmit(e) {
    // Prevent duplicate submissions
    if (this.isProcessing) {
      e.preventDefault();
      return;
    }

    // Go straight to cart page, use html form submit event.
    if(this.cartType == 'page' && this.cartAction != 'show_added_message') {
      return;
    }

    e.preventDefault();
    this.isProcessing = true;

    const currentForm = e.currentTarget;
    const currentButton = currentForm.querySelector('[data-quick-add-button]');
    const productWrapper = currentForm.closest('.quick-add-wrapper.is-singular');

    // Store original button state for cleanup
    let previousInnerHTML = null;
    let isDesktopQuickAdd = false;

    try {
      if (!productWrapper) {
        console.error('Product wrapper not found.');
        return false;
      }

      // Retrieve liveRegion
      const liveRegion = currentForm.querySelector('.sr-only[aria-live="polite"]');
      
      isDesktopQuickAdd = currentButton.classList.contains('quick-add-button-desktop');

      // Loading spinner.
      if (isDesktopQuickAdd) {
        previousInnerHTML = currentButton.innerHTML;
        currentButton.classList.add('is-loading');
        currentButton.innerHTML = `<svg viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="1.6em" height="1.6em" class="spin flex-full"><g clip-path="url(#clip0_3605_47041)"><path d="M12.5 23C6.42487 23 1.5 18.0751 1.5 12C1.5 5.92487 6.42487 1 12.5 1C18.5751 1 23.5 5.92487 23.5 12C23.5 15.1767 22.1534 18.0388 20 20.0468" stroke="currentColor" stroke-width="1" stroke-linecap="round"/></g><defs><clipPath id="clip0_3605_47041"><rect width="24" height="24" fill="none" transform="translate(0.5)"/></clipPath></defs>${ this.translationsObject.translations.loading }</svg>`;
      }

      const formData = new FormData(currentForm);
      const data = new URLSearchParams(formData).toString();
      const response = await window.fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: data,
      });
      if (!response.ok) {
        // FIXME: error handling
        return false;
      }

      // Update cart drawer
      if(this.cartType == 'drawer') {
        const responseJson = await response.json();
        window.eventBus.emit('update:cart:drawer', responseJson);
      }

      const languageParam = !this.languageUrl || this.languageUrl == '/' ? '' : this.languageUrl;
      const response2 = await window.fetch(`${languageParam}/cart?view=compare`);
      if (!response2.ok) {
        // FIXME: error handling
        return false;
      }
      const cart = await response2.json();

      if(this.cartType == 'drawer' && this.cartAction == 'go_to_or_open_cart') {
        window.eventBus.emit('open:cart:drawer', { scrollToTop: true });
      }
      else {
        if (isDesktopQuickAdd) {
          currentButton.classList.remove('is-loading');
          currentButton.innerHTML = this.translationsObject.translations.productAdded;
        }
      }

      if (this.cartType == 'drawer') {
        const successMessage = productWrapper.getAttribute('data-product-added');
        if (liveRegion && successMessage) {
          liveRegion.textContent = successMessage;
        }
      }
      
      this.theme.updateCartCount(cart);

      if (isDesktopQuickAdd) {
        setTimeout(() => {
          const translationKey = currentButton.dataset.addToCartTranslationKey || 'addToCart';
          currentButton.classList.remove('is-loading');
          currentButton.innerHTML = this.translationsObject.translations[translationKey];
        }, 2000);
      }

    } catch (e) {
      console.error('Unable to add to cart: ', e);
      // FIXME error handling
    } finally {
      // Ensure button is always restored to a usable state on error
      if (currentButton && isDesktopQuickAdd && previousInnerHTML) {
        // Only restore if button still has the loading class (error path)
        if (currentButton.classList.contains('is-loading')) {
          currentButton.classList.remove('is-loading');
          currentButton.innerHTML = previousInnerHTML;
        }
      }
      this.isProcessing = false;
    }

    return false;
  }
}

;// ./src/javascripts/webcomponents/product-recommendations.js


class productRecommendations extends HTMLElement {
  constructor() {
    super();

    this.isAlreadyLoaded = this.querySelector('.product-page-related-products');
    this.abortController = null; // Abort controller for request cancellation
    this.intersectionObserver = null;
    this.idleCallback = null;
    this.loadTimer = null;
    this.imageIntersectionObserver = null;
    this.imageLoadHandler = null;
    this.imageAnimationFrame = null;
    this.initialImagesPromoted = false;
    this.isLoading = false;
    this.isLoaded = false;
    this.bindEventHandlers();
  }

  connectedCallback() {
    this.addEventListeners();
    this.init();
  }

  bindEventHandlers() {
    this.debouncedRenderRecommendationsBound = this.debouncedRenderRecommendations.bind(this);
  }

  addEventListeners() {
    if (window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', this.debouncedRenderRecommendationsBound);
    }
  }

  debouncedRenderRecommendations() {
    if (this.renderTimeout) {
      clearTimeout(this.renderTimeout);
    }

    // Cancel any pending requests
    if (this.abortController) {
      this.abortController.abort();
    }

    // Use longer delay in design mode to allow server to process setting changes
    const delay = window.Shopify.designMode ? 800 : 100;
    this.renderTimeout = setTimeout(() => this.renderRecommendations(), delay);
  }

  init() {
    // Remove existing products so the new ones can be loaded.
    if(this.isAlreadyLoaded) this.isAlreadyLoaded.remove();

    window.wetheme.webcomponentRegistry.register({key: 'product-recommendations'});
    this.hidden = false;
    this.setAttribute('aria-busy', 'true');

    // In design mode, render immediately so setting changes remain responsive.
    if (window.Shopify.designMode) {
      this.renderRecommendations();
      return;
    }

    // The parser starts this request from the section markup before deferred
    // modules execute. This zero-delay fallback covers cart recommendations and
    // any environment where the early request wasn't available.
    this.loadTimer = setTimeout(() => this.renderRecommendations(), 0);
  }

  renderRecommendations() {
    if (this.isLoading || (this.isLoaded && !window.Shopify.designMode)) return;

    this.cancelScheduledLoad();

    // Cancel any existing request
    if (this.abortController) {
      this.abortController.abort();
    }

    // Create new abort controller for this request
    this.abortController = new AbortController();
    this.isLoading = true;
    this.hidden = false;
    this.setAttribute('aria-busy', 'true');

    // Add cache-busting parameter in design mode
    let url = this.dataset.recommendationsUrl;
    if (window.Shopify.designMode) {
      url += `&t=${Date.now()}`;
    }

    const earlyRequest = !window.Shopify.designMode
      ? window.mdhRecommendationRequests?.get(url)
      : null;

    const requestMarkup = () => fetch(url, {
      signal: this.abortController.signal,
      credentials: 'same-origin',
    }).then((response) => {
      if (!response.ok) throw new Error(`Unable to load product recommendations (${response.status})`);
      return response.text();
    });

    const recommendationMarkup = earlyRequest
      ? earlyRequest.then((text) => text || requestMarkup())
      : requestMarkup();

    recommendationMarkup
      .then((text) => {
        var container = document.createElement("div");
        container.innerHTML = text;
        const recommendations = container.querySelector('product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          // Dynamically injected cards must be ready as one stable layout. The
          // theme's staggered reveal otherwise leaves transparent, translated
          // cards floating over the section for more than a second.
          recommendations.querySelectorAll('[data-animate]').forEach((element) => {
            element.removeAttribute('data-animate');
            element.removeAttribute('data-animate-left');
            element.removeAttribute('data-animate-left-bold');
            element.removeAttribute('data-animate-right-bold');
            element.removeAttribute('data-animate-order');
            element.removeAttribute('data-animate-order-ipad');
            element.removeAttribute('data-animate-order-mobile');
            element.removeAttribute('data-animate-overflow-item');
          });
          recommendations.querySelectorAll('[data-animate-overflow-container]').forEach((element) => {
            element.removeAttribute('data-animate-overflow-container');
          });

          this.decorateRecommendationImages(recommendations);
          this.innerHTML = recommendations.innerHTML;
          this.isLoaded = true;
          this.classList.add('product-recommendations--loaded');
          this.setAttribute('aria-busy', 'false');
          this.bindRecommendationImageStates();
          this.scheduleRecommendationImageLoading();
          this.quickAddButtons = null;
          this.enhanceRecommendationCards();

          const sectionLoadedEvent = new CustomEvent('theme:section:load', {
            detail: {
              sectionId: this.dataset.sectionId,
            },
          });

          document.dispatchEvent(sectionLoadedEvent);

          const recommendationsLoadedEvent = new CustomEvent('recommendations:loaded');
          document.dispatchEvent(recommendationsLoadedEvent);
        } else {
          this.hideEmptyRecommendations();
        }
      })
      .catch((e) => {
        // Don't log errors for aborted requests
        if (e.name !== 'AbortError') {
          console.error(e);
          this.hideEmptyRecommendations();
        }
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  cancelScheduledLoad() {
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
      this.intersectionObserver = null;
    }

    if (this.idleCallback !== null && 'cancelIdleCallback' in window) {
      window.cancelIdleCallback(this.idleCallback);
      this.idleCallback = null;
    }

    if (this.loadTimer) {
      clearTimeout(this.loadTimer);
      this.loadTimer = null;
    }
  }

  enhanceRecommendationCards(attempt = 0) {
    clearTimeout(this.cardEnhancementTimer);
    this.cardEnhancementTimer = null;
    if (!this.isConnected || this.hidden || this.quickAddButtons) return;
    const theme = window.wetheme;
    // Recommendations can arrive before the deferred theme bundle. Keep the
    // rendered row visible while waiting for its optional UI enhancements.
    if (typeof theme?.addBadges !== 'function' || typeof theme?.registerComponent !== 'function') {
      if (attempt < 40) this.cardEnhancementTimer = setTimeout(() => this.enhanceRecommendationCards(attempt + 1), 250);
      return;
    }
    try {
      theme.addBadges(this, 1000);
      this.quickAddButtons = new QuickAdd(theme, this);
    } catch (error) {
      console.error('Unable to enhance recommendation controls:', error);
    }
  }

  hideEmptyRecommendations() {
    clearTimeout(this.cardEnhancementTimer);
    this.cardEnhancementTimer = null;
    this.cleanupRecommendationImageScheduling();
    this.innerHTML = '';
    this.hidden = true;
    this.isLoaded = true;
    this.setAttribute('aria-busy', 'false');
  }

  decorateRecommendationImages(container) {
    const initialImageCount = this.getInitialRecommendationImageCount();

    container.querySelectorAll('img[data-product-card-image]').forEach((image, index) => {
      image.decoding = 'async';
      image.classList.add('product-recommendations__product-image');
      const wrapper = image.closest('.responsive-image-wrapper');
      wrapper?.classList.add('product-recommendations__image-loading');

      // Shopify can omit the Liquid-generated quality URL for some source PNGs.
      // Build the same tiny CDN transform from the existing image URL so those
      // products receive the blurred preview too. This is scoped only to cards
      // that explicitly opted into the low-quality placeholder.
      if (wrapper?.hasAttribute('data-low-quality-placeholder')
        && !wrapper.style.getPropertyValue('--responsive-image-placeholder')) {
        const imageUrl = image.getAttribute('src');
        if (imageUrl) {
          const placeholderUrl = new URL(imageUrl, window.location.origin);
          placeholderUrl.searchParams.set('width', '120');
          placeholderUrl.searchParams.set('quality', '45');
          wrapper.style.setProperty('--responsive-image-placeholder', `url('${placeholderUrl}')`);
        }
      }

      // Set priority attributes before the HTML enters the live DOM so the
      // browser discovers the first visible cards at their final priority.
      if (index < initialImageCount) {
        image.loading = 'eager';
        image.fetchPriority = 'high';
      }
    });

    this.initialImagesPromoted = true;
  }

  bindRecommendationImageStates() {
    this.querySelectorAll('img[data-product-card-image]').forEach((image) => {
      const wrapper = image.closest('.responsive-image-wrapper');
      if (!wrapper) return;

      const revealImage = () => {
        if (wrapper.classList.contains('product-recommendations__image-loaded')) return;
        wrapper.classList.remove('product-recommendations__image-loading');
        wrapper.classList.add('product-recommendations__image-loaded');
      };

      const revealAfterDecode = () => {
        if (typeof image.decode === 'function') {
          image.decode().catch(() => {}).finally(revealImage);
        } else {
          revealImage();
        }
      };

      if (image.complete && image.naturalWidth > 0) {
        revealAfterDecode();
      } else {
        image.addEventListener('load', revealAfterDecode, { once: true });
        image.addEventListener('error', () => {
          wrapper.classList.remove('product-recommendations__image-loading');
          wrapper.classList.add('product-recommendations__image-error');
        }, { once: true });
      }
    });
  }

  scheduleRecommendationImageLoading() {
    if (this.initialImagesPromoted) return;

    this.cleanupRecommendationImageScheduling();
    this.initialImagesPromoted = false;

    this.imageLoadHandler = () => this.promoteInitialRecommendationImages();

    if (document.readyState === 'complete') {
      this.imageAnimationFrame = requestAnimationFrame(() => {
        this.imageAnimationFrame = null;
        this.imageLoadHandler?.();
      });
    } else {
      window.addEventListener('load', this.imageLoadHandler, { once: true });
    }

    if ('IntersectionObserver' in window) {
      this.imageIntersectionObserver = new IntersectionObserver((entries) => {
        if (!entries[0].isIntersecting) return;
        this.promoteInitialRecommendationImages();
      }, { rootMargin: '1200px 0px 1200px 0px' });
      this.imageIntersectionObserver.observe(this);
    }
  }

  promoteInitialRecommendationImages() {
    if (this.initialImagesPromoted) return;
    this.initialImagesPromoted = true;

    const imageCount = this.getInitialRecommendationImageCount();

    [...this.querySelectorAll('img[data-product-card-image]')]
      .slice(0, imageCount)
      .forEach((image) => {
        image.loading = 'eager';
        image.fetchPriority = 'high';
      });

    this.cleanupRecommendationImageScheduling();
  }

  getInitialRecommendationImageCount() {
    if (window.matchMedia('(max-width: 809px)').matches) return 2;
    if (window.matchMedia('(max-width: 1024px)').matches) return 4;
    return 5;
  }

  cleanupRecommendationImageScheduling() {
    if (this.imageAnimationFrame !== null) {
      cancelAnimationFrame(this.imageAnimationFrame);
      this.imageAnimationFrame = null;
    }

    if (this.imageIntersectionObserver) {
      this.imageIntersectionObserver.disconnect();
      this.imageIntersectionObserver = null;
    }

    if (this.imageLoadHandler) {
      window.removeEventListener('load', this.imageLoadHandler);
      this.imageLoadHandler = null;
    }
  }

  disconnectedCallback() {
    clearTimeout(this.cardEnhancementTimer);
    this.cardEnhancementTimer = null;
    this.cancelScheduledLoad();
    this.cleanupRecommendationImageScheduling();

    if (this.renderTimeout) {
      clearTimeout(this.renderTimeout);
    }

    // Cancel any pending requests
    if (this.abortController) {
      this.abortController.abort();
    }

    if (window.Shopify.designMode) {
      document.removeEventListener('shopify:section:load', this.debouncedRenderRecommendationsBound);
    }
  }

  // check if we're on mobile
  isMobile = () => {
    return window.matchMedia('(max-width: 1023px)').matches;
  }
}

customElements.define('product-recommendations', productRecommendations);

/******/ })()
;
